'use client';

import React, { useEffect, useRef, useState } from 'react';

import { Tooltip } from '@mui/material';
import classNames from 'classnames';

import { IconCircleInfo } from '@/blocks/components/Icons';
import typography from '@/styles/typography.module.scss';

import styles from './styles.module.scss';

interface Props {
  tooltipContent: {
    title: React.ReactNode;
  }[];
}

export const WelcomeBonusTooltip = ({ tooltipContent }: Props) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState<
    | 'right'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
    | 'top'
  >('right');
  const [hovered, setHovered] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleTooltipToggle = () => {
    setOpen(!open);
  };

  const handleMouseEnter = () => {
    setHovered(true);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
    setOpen(false);
  };

  useEffect(() => {
    const updatePlacement = () => {
      const newPlacement = window.innerWidth <= 992 ? 'bottom' : 'right';
      setPlacement(newPlacement);
    };
    updatePlacement();
    window.addEventListener('resize', updatePlacement);
    return () => window.removeEventListener('resize', updatePlacement);
  }, []);

  const handleScroll = () => {
    setOpen(false);
    setHovered(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div ref={scrollContainerRef}>
      <Tooltip
        open={open || hovered}
        slotProps={{
          popper: { className: styles.popperContent },
          tooltip: { className: styles.tooltipContent },
          arrow: { className: styles.arrowTooltip },
        }}
        title={
          <div>
            {tooltipContent.map((el, key) => (
              <div className={classNames(styles.tooltipContentItem, typography.bodyS)} key={key}>
                <span>{key + 1}.</span>
                <p>{el.title}</p>
              </div>
            ))}
          </div>
        }
        placement={placement}
        arrow
      >
        <div
          className={styles.icon}
          onClick={handleTooltipToggle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <IconCircleInfo />
        </div>
      </Tooltip>
    </div>
  );
};
